import { TaskVariable } from '../../interfaces/variable-services/task-variable';
import { DestinationTaskConfigBase } from '../config-objects/destination-service-config-base';

/**
 * Configuration for a GetVariable task — reads one or more named variables and
 * writes their values into record.processingData at the specified path. Read source
 * is determined by TaskVariable.scopeId: empty = contextData/flowVariables (set by
 * SetVariable), platform scope strings = DB-stored variables, 'PARAM' = flow parameters.
 */
export class GetVariableConfig extends DestinationTaskConfigBase {
	/**
	 * Array of variable read operations. Each entry reads one variable by name and
	 * writes its value to processingData at the dot-notation path.
	 * @default []
	 */
	variables: TaskVariable[] = [];

	constructor(init?: Partial<GetVariableConfig>) {
		super(init);
		if (init) {
			Object.assign(this, init);
		}
	}
}
